/* نبأ: صفحة المنتج على الجوال (قرار المستخدم 2026-10-21).
   - سطر السعر + التقييم، وصف «الدفع السريع + الكمية» تحت الحقول، ثم «أضف للسلة».
   - شريط ثابت أسفل الشاشة فيه زرّان فقط (الدفع السريع وأضف للسلة) يظهر حين تخرج أزرار الصفحة من الشاشة ويختفي حين تعود.
     الأزرار نفسها تنتقل للشريط (لا نسخ)، فـApple Pay ومنطق «أكمل الحقول المطلوبة» يبقيان يعملان كما هما. */
(function () {
  var MOBILE = window.matchMedia('(max-width: 749px)');
  var EN = /^en/i.test(document.documentElement.lang || '');
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var RATING = { stars: 5.0, label: EN ? 'over 2,500 reviews' : 'أكثر من 2,500 تقييم', href: ROOT + 'pages/reviews' };

  function setup() {
    var info = document.querySelector('.product__info-container');
    var btns = info && info.querySelector('.product-form__buttons');
    if (!btns || btns.dataset.nabaReady) return;
    btns.dataset.nabaReady = '1';

    var priceEl = info.querySelector('.price');
    var priceBlock = priceEl && priceEl.closest('.product__info-container > *');
    if (priceBlock && !info.querySelector('.naba-pricerow')) {
      var row = document.createElement('div');
      row.className = 'naba-pricerow';
      priceBlock.before(row);
      row.appendChild(priceBlock);
      var a = document.createElement('a');
      a.className = 'naba-rating';
      a.href = RATING.href;
      a.innerHTML = '<span class="s" aria-hidden="true">★★★★★</span><b>' + RATING.stars.toFixed(1) + '</b><span>· ' + RATING.label + '</span>';
      a.setAttribute('aria-label', EN ? ('Rated ' + RATING.stars.toFixed(1) + ' out of 5, ' + RATING.label) : ('التقييم ' + RATING.stars.toFixed(1) + ' من 5، ' + RATING.label));
      row.appendChild(a);
    }

    var pay = btns.querySelector('.shopify-payment-button');
    var qty = info.querySelector('.product-form__quantity');
    if (pay && qty) {
      var buy = document.createElement('div');
      buy.className = 'naba-buyrow';
      btns.prepend(buy);
      buy.appendChild(pay);
      buy.appendChild(qty);
    }

    var form = btns.closest('form');
    // سطر صغير فوق زرّي الشريط: ما الذي يشتريه (المنتج والكمية) — يتحدّث مع الكمية
    var info = document.createElement('div');
    info.className = 'naba-dock-info';
    var title = (info.title = (document.querySelector('.product__title h1') || document.querySelector('.product__title') || {}).textContent || '').trim();
    function refreshInfo() {
      var q = (form && form.querySelector('.quantity__input')) || document.querySelector('.quantity__input');
      var n = q ? parseInt(q.value, 10) || 1 : 1;
      info.innerHTML = '<span class="t">' + title.replace(/[<>&]/g, '') + '</span><b>· الكمية ' + n + '</b>';
    }
    refreshInfo();
    document.addEventListener('change', function (e) { if (e.target && e.target.classList && e.target.classList.contains('quantity__input')) refreshInfo(); }, true);
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.quantity__button')) setTimeout(refreshInfo, 50); }, true);
    btns.prepend(info);
    // حارس الحقول (naba-guard) لا يعيد الفحص أثناء الكتابة، فيبقى القفل حتى الضغط؛ نعيده هنا ليتبدّل الشريط فوراً
    document.addEventListener('input', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-naba-required]') && window.__nabaCheckForm) window.__nabaCheckForm(form, false);
    }, true);

    // الشريط الثابت: حارس مكان الأزرار؛ حين يصعد فوق الشاشة تلتصق الأزرار بالأسفل، ومكانها يُحجز حتى لا تقفز الصفحة
    var spacer = document.createElement('div');
    spacer.className = 'naba-dock-spacer';
    btns.before(spacer);
    var docked = false;
    function dock(on) {
      if (on === docked || !MOBILE.matches) return;
      docked = on;
      spacer.style.height = on ? btns.offsetHeight + 'px' : '0px';
      btns.classList.toggle('naba-docked', on);
      document.documentElement.classList.toggle('naba-has-dock', on);
    }
    new IntersectionObserver(function (es) {
      var e = es[0];
      dock(!e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(spacer);
    MOBILE.addEventListener('change', function () { if (!MOBILE.matches) dock(false); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();
